import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCaregiverMemberMutationVariables = Types.Exact<{
  data: Types.UpdateCaregiverMemberInput;
}>;


export type UpdateCaregiverMemberMutation = { __typename?: 'Mutation', updateCaregiverMember: { __typename?: 'OrganisationMemberUser', id: string, role: Types.OrganisationRole } };


export const UpdateCaregiverMemberDocument = gql`
    mutation UpdateCaregiverMember($data: UpdateCaregiverMemberInput!) {
  updateCaregiverMember(data: $data) {
    id
    role
  }
}
    `;
export type UpdateCaregiverMemberMutationFn = Apollo.MutationFunction<UpdateCaregiverMemberMutation, UpdateCaregiverMemberMutationVariables>;

/**
 * __useUpdateCaregiverMemberMutation__
 *
 * To run a mutation, you first call `useUpdateCaregiverMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaregiverMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaregiverMemberMutation, { data, loading, error }] = useUpdateCaregiverMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCaregiverMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaregiverMemberMutation, UpdateCaregiverMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaregiverMemberMutation, UpdateCaregiverMemberMutationVariables>(UpdateCaregiverMemberDocument, options);
      }
export type UpdateCaregiverMemberMutationHookResult = ReturnType<typeof useUpdateCaregiverMemberMutation>;
export type UpdateCaregiverMemberMutationResult = Apollo.MutationResult<UpdateCaregiverMemberMutation>;
export type UpdateCaregiverMemberMutationOptions = Apollo.BaseMutationOptions<UpdateCaregiverMemberMutation, UpdateCaregiverMemberMutationVariables>;